"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorPickerItem = void 0;
var React = require("react");
var ColorPickerItem_st_css_1 = require("./ColorPickerItem.st.css");
var radio_button_1 = require("wix-ui-core/radio-button");
var dataHooks_1 = require("../dataHooks");
var Tooltip_1 = require("../../Tooltip");
var MobileTooltip_1 = require("./MobileTooltip");
var TPAComponentsConfig_1 = require("../../TPAComponentsConfig");
var tooltipCommonProps_1 = require("./tooltipCommonProps");
var classnames_1 = require("classnames");
/** ColorPickerItem */
var ColorPickerItem = /** @class */ (function (_super) {
    __extends(ColorPickerItem, _super);
    function ColorPickerItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { focused: false, focusedByKeyboard: false };
        _this.getRadioVisual = function (_a) {
            var _b;
            var value = _a.value;
            return (React.createElement("div", { className: classnames_1.default(ColorPickerItem_st_css_1.classes.radioOuter, (_b = {},
                    _b[ColorPickerItem_st_css_1.classes.focused] = _this.props.withFocusRing && _this.state.focusedByKeyboard,
                    _b)) },
                React.createElement("div", { className: ColorPickerItem_st_css_1.classes.radioInner, style: { backgroundColor: value } })));
        };
        _this.getRadio = function (props, isMobile) {
            if (isMobile === void 0) { isMobile = false; }
            var radioVisual = _this.getRadioVisual(props);
            if (props.tooltip) {
                return isMobile ? (React.createElement(MobileTooltip_1.MobileTooltip, { tooltip: props.tooltip }, radioVisual)) : (React.createElement(Tooltip_1.Tooltip, __assign({}, tooltipCommonProps_1.TOOLTIP_COMMON_PROPS, { "data-hook": props.tooltipDataHook, content: props.tooltip }), radioVisual));
            }
            return radioVisual;
        };
        _this.getFocusOnHoverBehaviour = function (isMobile) {
            if (isMobile) {
                return {};
            }
            return {
                onHover: function () {
                    _this.setState({ focused: true });
                },
                onIconBlur: function () {
                    _this.setState({ focused: false });
                },
                onFocusByKeyboard: function () {
                    _this.setState({ focusedByKeyboard: true });
                },
                onBlur: function () {
                    _this.setState({ focusedByKeyboard: false });
                },
            };
        };
        _this.render = function () {
            var focused = _this.state.focused;
            var _a = _this.props, value = _a.value, checked = _a.checked, onChange = _a.onChange, className = _a.className, disabled = _a.disabled, isCrossedOut = _a.isCrossedOut, tooltipDataHook = _a.tooltipDataHook, name = _a.name;
            var finalChecked = checked && !disabled;
            return (React.createElement(TPAComponentsConfig_1.TPAComponentsConsumer, null, function (_a) {
                var mobile = _a.mobile;
                return (React.createElement(radio_button_1.RadioButton, __assign({ className: ColorPickerItem_st_css_1.st(ColorPickerItem_st_css_1.classes.root, { checked: checked, focused: focused, isCrossedOut: isCrossedOut }, className), "aria-label": _this.props['aria-label'], "data-hook": ColorPickerItem.displayName, "data-tooltip-hook": tooltipDataHook, disabled: disabled, checked: finalChecked, checkedIcon: _this.getRadio(__assign(__assign({}, _this.props), { checked: true }), mobile), value: value, uncheckedIcon: _this.getRadio(__assign(__assign({}, _this.props), { checked: false }), mobile), onChange: onChange }, _this.getFocusOnHoverBehaviour(mobile), { name: name })));
            }));
        };
        return _this;
    }
    ColorPickerItem.displayName = dataHooks_1.colorPickerItemDataHook;
    ColorPickerItem.defaultProps = {
        tooltipDataHook: dataHooks_1.colorPickerItemTooltipDataHook,
    };
    return ColorPickerItem;
}(React.Component));
exports.ColorPickerItem = ColorPickerItem;
//# sourceMappingURL=ColorPickerItem.js.map